export const NURSE_TYPE = [2]; //0 - Student, 1 - Pharmacy
export const MEDICAL_TYPE = [0, 1, 3, 4, 7]; //  4 - Medical, 5 - GP, 2 - NCHD, 4 - Consultant
export const POSTCODE_COUNTRIES = [0, 1, 2, 4, 6, 7];
export const DOCTOR_TYPE = [0, 2, 3];
export const IRELAND = [3];
export const REIMBURSEMENT_TYPE = [1, 3, 7];
export const EXAM_PREP_ROLES = [1, 7];

export const USER_CONSTRAINS = {
  first_name: {
    presence: {message: 'First name is required'},
    length: {
      maximum: 20,
      tooLong: 'First name allowed only 20 symbols'
    }
  },
  last_name: {
    presence: {message: 'Last name is required'},
    length: {
      maximum: 20,
      tooLong: 'Last name allowed only 20 symbols'
    }
  },
  email: {
    email: {message: 'Email invalid'}
  },
  email_confirmation: {
    equality: {
      attribute: 'email',
      message: 'Confirmation Email must be the same as Email'
    }
  },
  user_type: {
    presence: {message: 'User type is required'}
  },
  password: {
    format: {
      pattern: '((?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{6,})',
      message: 'Must be at least 6 characters and contain at least one number and one capital letter'
    }
  },
  phone_number: {
    numericality: { message: 'Phone isn`t a number'},
    length: {
      maximum: 12,
      minimum : 5,
      tooShort: 'Minimum is 5 characters',
      tooLong: 'Maximum is 12 characters'
    }
  },
  country: {
    presence: {message: 'Country is required'}
  },
  postcode: {
    presentPerCountry: {
      message: 'Postcode/Zipcode is required',
      countries: POSTCODE_COUNTRIES
    },
    length: {
      maximum: 10,
      tooLong: 'Maximum is 10 characters'
    }
  },
  imc: {
    presentPerIrelandDoctor: {
      message: 'IMC is required',
      user_types: DOCTOR_TYPE,
      countries: IRELAND
    }
  },
  // nmbi: {
  //   presentPerUserType: {
  //     message: 'NMBI is required',
  //     user_types: NURSE_TYPE
  //   }
  // }
};

export const LOGIN_USER = {
  email: {
    email: {message: 'Email invalid'}
  },
  password: {
   presence: {message: 'Password is required' }
  }
};


export const NEW_PASSWORD = {
  password: {
    format: {
      pattern: '((?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{6,})',
      message: 'Must be at least 6 characters and contain at least one number and one capital letter'
    }
  },
  password_confirmation: {
    equality: {
      attribute: 'password',
      message: 'The New Password must be the same as the Repeat New Password'
    }
  }
};


export const USER_UPDATE_CONSTRAINS = {
  email: {
    presence: { message: 'Email is required' },
    email: { message: 'Email invalid' }
  },
  first_name: {
    presence: {message: 'First name is required'},
    length: {
      maximum: 20,
      tooLong: 'First name allowed only 20 symbols'
    }
  },
  last_name: {
    presence: {message: 'Last name is required'},
    length: {
      maximum: 20,
      tooLong: 'Last name allowed only 20 symbols'
    }
  },
  user_type: {
    presence: {message: 'User type is required'}
  },
  phone_number: {
    numericality: { message: 'Phone isn`t a number'},
    length: {
      maximum: 12,
      minimum : 5,
      tooShort: 'Minimum is 5 characters',
      tooLong: 'Maximum is 12 characters'
    }
  },
  country: {
    presence: {message: 'Country is required'}
  },
  postcode: {
    presentPerCountry: {
      message: 'Postcode/Zipcode is required',
      countries: POSTCODE_COUNTRIES
    },
    length: {
      maximum: 10,
      tooLong: 'Maximum is 10 characters'
    }
  },
  imc: {
    presentPerIrelandDoctor: {
      message: 'IMC is required',
      user_types: DOCTOR_TYPE,
      countries: IRELAND
    }
  },
  // nmbi: {
  //   presentPerUserType: {
  //     message: 'NMBI is required',
  //     user_types: NURSE_TYPE
  //   }
  // }
};



// WEBPACK FOOTER //
// ./src/constants/usersConstrains.js